import { HelperCore } from '@/common/helper';

const modules = {
  wx: {
    js: '//res.wx.qq.com/open/js/jweixin-1.6.0.js',
    checked: !!window.wx,
    loaded: false,
  },
  SpeechSDK: {
    js: 'https://s2.ssl.qhres2.com/!88ed4ac9/microsoft.cognitiveservices.speech.sdk.bundle-min.js',
    checked: !!window.SpeechSDK,
    loaded: false,
  },
  qaSdk: {
    js: 'https://s2.ssl.qhres2.com/!21e2f7ae/qasdk-js_prod_2.2.4.js',
    checked: !!(window.qaSdk || window.QaSdk),
    loaded: false,
  },
  chatsdk: {
    js: 'https://bot.n.cn/js/chatsdk-1.0.js',
    checked: !!window.AISO_CHAT_TOKEN,
    loaded: false,
  },
}

const loadModule = (name) => {
  console.log('>loadModule', name);
  
  return new Promise((resolve, reject) => {
    if (!modules[name]) {
      reject(false);
    } else {
      if (modules[name].checked || modules[name].loaded) {
        resolve(true);
      } else {
        HelperCore.loadJs(modules[name].js, () => {
          modules[name].loaded = true;
          resolve(true);
        }, () => {
          reject(false);
        }, modules[name].tagAppend)
      }
    }
  });
}

const initModule = () => {
  loadModule('chatsdk').catch(err => null);
}

initModule();

export {
  initModule,
  loadModule
}